import React, { useState } from "react";
import apiClient from "../../../../api/apiClient";
import { useDebounce } from "../../../../hooks/useDebounce";

// Searchable user typeahead over GET /admin/users?search=... Calls onSelect(user)
// when a result is clicked and clears its own input/results afterward.
const UserPicker = ({ onSelect, placeholder = "Search users by name or email…", excludeUserIds = [] }) => {
    const [term, setTerm] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const [runSearch] = useDebounce((q) => {
        if (!q.trim()) {
            setResults([]);
            setLoading(false);
            return;
        }
        apiClient
            .get(`/admin/users?search=${encodeURIComponent(q)}`)
            .then((res) => {
                const list = Array.isArray(res.data) ? res.data : res.data.users;
                setResults((list || []).filter((u) => !excludeUserIds.includes(u.userId)));
            })
            .catch(() => setResults([]))
            .finally(() => setLoading(false));
    }, 300);

    const handleChange = (e) => {
        const value = e.target.value;
        setTerm(value);
        setOpen(true);
        setLoading(true);
        runSearch(value);
    };

    const handleSelect = (user) => {
        onSelect(user);
        setTerm("");
        setResults([]);
        setOpen(false);
    };

    return (
        <div className="admin-user-picker">
            <input
                className="admin-form-input"
                placeholder={placeholder}
                value={term}
                onChange={handleChange}
                onFocus={() => setOpen(true)}
                onBlur={() => setTimeout(() => setOpen(false), 150)}
            />
            {open && term.trim() && (
                <div className="admin-user-picker-results">
                    {loading ? (
                        <div className="admin-user-picker-empty">Searching…</div>
                    ) : results.length === 0 ? (
                        <div className="admin-user-picker-empty">No matching users.</div>
                    ) : (
                        results.map((u) => (
                            <div
                                key={u.userId}
                                className="admin-user-picker-row"
                                onMouseDown={() => handleSelect(u)}
                            >
                                <span className="admin-user-picker-name">{u.firstName} {u.lastName}</span>
                                <span className="admin-license-meta">{u.email}</span>
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default UserPicker;
